/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Equal_Muddy_Shell_BloomInputs */

const fr_equal_muddy_shell_bloom = /** @type {(inputs: Equal_Muddy_Shell_BloomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bienvenue sur l'application, n'hésitez pas a changer ton nom d'utilisateur dans ton espace profil.`)
};

/**

* @param {Equal_Muddy_Shell_BloomInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const equal_muddy_shell_bloom = /** @type {((inputs?: Equal_Muddy_Shell_BloomInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Equal_Muddy_Shell_BloomInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_equal_muddy_shell_bloom(inputs)
});